import { ADD_FAVORITE_TOGGLE, FAVORITES_FORM_FOCUSED } from 'constants/Favorites';

export function toggleAddFavorite(isVisible) {
  return {
    type: ADD_FAVORITE_TOGGLE,
    payload: isVisible
  };
}

export function setFormFocus(isFocused) {
  return {
    type: FAVORITES_FORM_FOCUSED,
    payload: isFocused
  };
}

export default {
  toggleAddFavorite,
  setFormFocus
};
